import React, { useEffect, useState } from "react";
import "./ReferPage.css";
import useUserInfo from "../../Hooks/useUserInfo";
import Invite from "../../assets/images/Invitefriends.png";
import { getUserDetails1, myReferrel } from "../../apis/user";
import Milestone from "../Milestone/milestone";
import { RWebShare } from "react-web-share";
import Tv from "../Tv/Tv";
import cancelIcon from "../../assets/Task/cancelicon.svg";
import copy from "../../assets/images/copy.png";
import { useAudio } from "../../Providers/AudioProvider";
import { logPageView } from "../../components/analytics";
import logo from "../../assets/images/meme-logo.svg";
import Cup from "../../assets/images/cup.svg";

const ReferPage = () => {
  const { watchScreen, userDetails, updateUserInfo, updatewatchScreenInfo } =
    useUserInfo();
  const [referrals, setReferrals] = useState([]);
  const playClick = useAudio();
  const [activeSection, setActiveSection] = useState("section1");

  const MileItem = [
    { invite: "Invite 3 Friends", points: 20000 },
    { invite: "Invite 5 Friends", points: 33333 },
    { invite: "Invite 10 Friends", points: 66667 },
    { invite: "Invite 15 Friends", points: 100000 },
    { invite: "Invite 20 Friends", points: 133333 },
    { invite: "Invite 25 Friends", points: 166667 },
    { invite: "Invite 30 Friends", points: 200000 },
    { invite: "Invite 35 Friends", points: 233333 },
    { invite: "Invite 40 Friends", points: 266667 },
    { invite: "Invite 45 Friends", points: 300000 },
    { invite: "Invite 50 Friends", points: 333333 },
    { invite: "Invite 55 Friends", points: 366667 },
    { invite: "Invite 60 Friends", points: 400000 },
    { invite: "Invite 65 Friends", points: 433333 },
    { invite: "Invite 70 Friends", points: 466667 },
    { invite: "Invite 75 Friends", points: 500000 },
    { invite: "Invite 80 Friends", points: 533333 },
    { invite: "Invite 85 Friends", points: 566667 },
    { invite: "Invite 90 Friends", points: 600000 },
    { invite: "Invite 95 Friends", points: 633333 },
    { invite: "Invite 100 Friends", points: 666667 },
  ];

  const getMyReferralList = async () => {
    const referrals = await myReferrel( );

    setReferrals(referrals.referrals);
  };
  useEffect(() => {
    logPageView("ReferalPage", "Referal Page");
  }, []);
  useEffect(() => {
    getMyReferralList();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: false,
      }));
    }, 1000);
  }, []);

  const shareToTelegram = () => {
    playClick();
    const url = encodeURIComponent(
   `${process.env.REACT_APP_IS_REDIRECT_URL}?startapp=${userDetails?.userDetails?.refId}`
    );
    const text = encodeURIComponent(
      "500 MemeTV tokens? Yup, just for existing! 🙌 💰 Stack up more by literally doing nothing. #doNothing"
    );
    const telegramUrl = `https://t.me/share/url?url=${url}&text=${text}`;

    window.open(telegramUrl, "_blank");
  };

  const goToTheMilstonePage = (component, name) => {
    playClick();
    updateUserInfo((prev) => ({
      ...prev,
      currentComponent: component,
      currentComponentText: name,
      lastComponent: userDetails?.userDetails?.currentComponent,
      lastComponentText: userDetails?.userDetails?.currentComponentText,
      refererCount: userDetails?.userDetails?.refererCount + 1,
    }));
  };
  const getUserDetailsOnly = async () => {
    let userDetails1;
    try {
      userDetails1 = await getUserDetails1(
        userDetails?.userDetails?.telegramId
      );
    } catch (error) {
      console.error("Error in updating or fetching user details:", error);
    }
    // Update state after both async calls are completed
    if (userDetails) {
      updateUserInfo((prev) => ({
        ...prev,
        userDetails: userDetails1,
      }));
      updatewatchScreenInfo((prev) => ({
        ...prev,
        boostersList: userDetails1?.boosters,
        totalReward: userDetails1?.balanceRewards,
        tapPoints: 0,
        booster: false,
        boosterSec: 0,
        boosterPoints: 0,
        boosterDetails: {},
        watchSec: 0,
      }));
    }
    return userDetails;
  };
  const goToThePage = (component, name) => {
    updateUserInfo((prev) => ({
      ...prev,
      currentComponent: component,
      currentComponentText: name,
      lastComponent: userDetails.currentComponent,
      lastComponentText: userDetails.currentComponentText,
      centerCount: userDetails.centerCount + 1,
    }));
  };
  const toogleMenu = () => {
    playClick();
    if (!watchScreen.booster) {
      const data = getUserDetailsOnly().then(() => {
        updateUserInfo((prev) => ({
          ...prev,
          isPlay: false,
          currentComponent: Tv,
          currentComponentText: "TVPage",
          lastComponent: userDetails?.userDetails.currentComponent,
          lastComponentText: userDetails?.userDetails.currentComponentText,
          isMenu: true,
          menuCount: userDetails?.userDetails?.menuCount + 1,
        }));
        // goToThePage(Battle, "BattlePage");
      });
    } else {
      goToThePage(Tv, "Tv");
    }
  };
  const [showPopup, setShowPopup] = useState(false);

  const handleCopy = () => {
    playClick();
    navigator.clipboard
      .writeText(
        `${process.env.REACT_APP_IS_REDIRECT_URL}?startapp=${userDetails?.userDetails?.refId}`
      )
      .then(() => {
        setShowPopup(true); // Show the popup
        setTimeout(() => setShowPopup(false), 2000); // Hide the popup after 3 seconds
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  return (
    <div className="info-img menupointer">
      <img
        onClick={() => {
          toogleMenu();
        }}
        src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
        className="cancel-imgpoints"
        style={{ cursor: "pointer", pointerEvents: "all" }}
      />
      <div
        className="menupointer"
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          flexDirection: "column",
          pointerEvents: "all",
          marginTop: "60px",
        }}
      >
        <div className="col-9 phasediv">
          <h2 class="do-earn text-center m-2">
            Invite <br />
            friends
          </h2>
          <p className="refer-earn mb-2">
            EARN 10,000 MEMETV TOKENS & <br />5 2X BOOSTERS FOR EVERY REFERRAL
          </p>
        </div>

        <div className="col-10 mt-2 refer">
          <div className="row claim-ref">
            <div className="col-12">
              <div className="container mt-2">
                <div className="mb-2 dis-refer">
                  <button
                    className={`btn-${
                      activeSection === "section1"
                        ? "primary1"
                        : "outline-primary1"
                    } me-2`}
                    onClick={() => setActiveSection("section1")}
                  >
                    MY REFERRALS
                  </button>
                  <button
                    className={`btn-${
                      activeSection === "section2"
                        ? "primary1"
                        : "outline-primary1"
                    }`}
                    onClick={() => setActiveSection("section2")}
                  >
                    MILESTONE
                  </button>
                </div>

                {activeSection === "section1" && (
                  <div className="scrollable">
                    <div className="bor-round">
                      {referrals.length > 0 ? (
                        <table className="table table-dark">
                          <tbody>
                            {referrals.map((item, index) => {
                              return (
                                <tr>
                                  <th scope="row">{index + 1}</th>
                                  <td>{item.name}</td>
                                  <td style={{ textAlign: "right" }}>
                                    {item.balanceRewards}MEMETV
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      ) : (
                        <div className="text-center p-3">
                          <p className="no-refer">you don’t have referrals</p>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {activeSection === "section2" && (
                  <div className="scrollable">
                    {MileItem.map((mile, index) => (
                      <>
                        <div className="row mb-2 cheap-stuff">
                          <div className="col-2" key={index}>
                            <img
                              src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cup.svg"
                              alt="milestone"
                              className="image"
                            />
                          </div>
                          <div className="col-9 stuff-text">
                            <h4>{mile.invite}</h4>
                            <p className="stuff-p">
                              <img src="https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png" />{" "}
                              +&nbsp;
                              {mile.points.toLocaleString()}
                            </p>
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div
            className="invite-fri"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              // marginBottom: "10px",
            }}
          >
            <h2
              onClick={() => {
                shareToTelegram();
              }}
            >
              {showPopup ? "Link copied to Clipboard" : " invite Friends"}
            </h2>
            {!showPopup && (
              <div onClick={handleCopy}>
                <img
                  src="https://d1ccopf5cw1hft.cloudfront.net/s3data/copy.png"
                  style={{ marginLeft: "20px", marginBottom: "10px" }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferPage;
